export type AuthAllapotNev = 'betolt' | 'kijelentkezve' | 'mfa_beallitas' | 'mfa_kod' | 'kesz';
export type MegerositesTipus = 'invite' | 'email';

export function megerositesParam(search: string): { tokenHash: string; tipus: MegerositesTipus } | null {
  const p = new URLSearchParams(search);
  const tokenHash = p.get('token_hash');
  const tipus = p.get('type');
  if (!tokenHash || (tipus !== 'invite' && tipus !== 'email')) return null;
  return { tokenHash, tipus };
}

/** Hová kell irányítani a védett útról; null = maradhat. A `vissza` csak belső út lehet. */
export function utDontes(allapot: AuthAllapotNev, ut: string): string | null {
  const vissza = encodeURIComponent(ut);
  if (allapot === 'kijelentkezve') return `/belepes?vissza=${vissza}`;
  if (allapot === 'mfa_beallitas' || allapot === 'mfa_kod') return `/belepes/mfa?vissza=${vissza}`;
  return null;
}

/** Nyílt átirányítás ellen: csak `/`-rel kezdődő, de nem `//`-rel kezdődő út. */
export function biztonsagosVissza(v: string | null): string {
  return v && v.startsWith('/') && !v.startsWith('//') ? v : '/leadek';
}
